module.exports = __webpack_public_path__ + "img/0-md.a3cdd32d.jpg";